export default __webpack_public_path__ + "static/media/recruit.b5300c69.jpg";